module.exports = __webpack_public_path__ + "static/media/r2d2.854b12c9.jpg";